import { UserInviteNextAction } from "~/gql/graphqlBase.generated";
import { type PublicInviteNextAction, SET_PASSWORD_FROM_EMAIL } from "~/pages/register/helpers/publicInviteApi";

const REGISTER_PATH_PREFIX = "/register/";
const TOKEN_IN_FRAGMENT = /(?:^#|&)changePasswordId=([^&]*)/;

let heldToken: string | null = null;

const decodeToken = (encoded: string): string | null => {
	try {
		return decodeURIComponent(encoded) || null;
	} catch {
		return null;
	}
};

const setupTokenFor = (
	nextAction: PublicInviteNextAction,
	responseToken: Maybe<string> | undefined,
	emailedToken: string | null
): Maybe<string> | undefined => {
	if (nextAction === SET_PASSWORD_FROM_EMAIL) return emailedToken;
	if (nextAction === UserInviteNextAction.SetPassword) return responseToken;
	return null;
};

const install = () => {
	if (!window.location.pathname.startsWith(REGISTER_PATH_PREFIX)) return;
	const match = TOKEN_IN_FRAGMENT.exec(window.location.hash);
	if (!match) return;
	heldToken = decodeToken(match[1]);
	window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
};

const take = (): string | null => {
	const token = heldToken;
	heldToken = null;
	return token;
};

export default { install, setupTokenFor, take };
